import React from "react";
import PropTypes from "prop-types";
import Buttons from "../Buttons/Buttons";

/**
 * Component that displays the BasketItem page
 *
 * @param {Object} props - The props object containing product information
 * @return {JSX.Element} BasketItem component JSX
 */
export default function BasketItem(props) {
  const { cover, productName, finalPrice, variantName, quantity } = props;
  return (
    <div className="basket_item">
      <div className="basket_link">
        <div className="basket_img">
          <img src={cover} alt="basket_item" />
        </div>
        <div className="basket_content">
          <span className="basket_title">
            {productName}
            <br></br>
            {variantName} <br></br>
            {quantity} x ₹{finalPrice} = ₹
            {(finalPrice * quantity).toLocaleString()}
          </span>
        </div>
      </div>
      <div className="basket_counter">
        <Buttons {...props} />
      </div>
    </div>
  );
}

BasketItem.propTypes = {
  cover: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  finalPrice: PropTypes.number.isRequired,
  variantName: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
  isMultiVariant: PropTypes.bool.isRequired
};
